import React, {ReactNode, useMemo, useState} from 'react';
import {View} from 'react-native';
import {Text} from '../../components/text';
import {useTabsStyles} from './Tabs.style';

interface TabItem {
  key: string;
  label: ReactNode;
  children: ReactNode;
  isEmpty?: boolean;
  emptyText?: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  defaultKey?: TabItem['key'];
  underlineActiveTab?: boolean;
  size?: 'small' | 'medium';
}

export function Tabs({defaultKey, items, underlineActiveTab = false, size = 'medium'}: TabsProps) {
  const [selectedKey, setSelectedKey] = useState(defaultKey ?? items[0].key);
  const styles = useTabsStyles();

  const selectedItem = useMemo(() => {
    return items.find((item) => item.key === selectedKey);
  }, [items, selectedKey]);

  return (
    <View style={styles.tabs}>
      <View style={styles.tabButtons}>
        {items.map(({key, label}, index) => (
          <View
            key={key}
            style={[
              styles.tab,
              index === 0 ? styles.firstTab : index === items.length - 1 ? styles.lastTab : undefined,
              size === 'small' ? styles.textCenter : null,
              selectedKey === key && underlineActiveTab ? styles.underlineActiveTab : null,
            ]}>
            <Text
              style={[
                size === 'small' ? styles.tabTextSmall : null,
                size === 'medium' ? styles.tabText : null,
                selectedKey === key ? styles.activeTab : styles.inactiveTab,
              ]}
              onPress={() => setSelectedKey(key)}>
              {label}
            </Text>
          </View>
        ))}
      </View>

      <View key={selectedKey} style={styles.tabContent}>
        {selectedItem?.isEmpty
          ? selectedItem?.emptyText ?? <Text style={styles.emptyText}>Нет данных</Text>
          : selectedItem?.children ?? null}
      </View>
    </View>
  );
}
